// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Batch register inward checks'"></sub-header>


  <form name="\$ctrl.form">
    <table class="misc-transaction__table table">
      <tbody>
      <tr>
        <td>1.</td>
        <td>Clearing file format</td>
        <td>
          <select ng-model="\$ctrl.input.format"
                  ng-options="format.value as format.description for format in \$ctrl.formats"
                  required></select>
        </td>
      </tr>
      <tr>
        <td>2.</td>
        <td>Perform clearing</td>
        <td>
          <select
            required
            ng-model="\$ctrl.input.performClearing"
            boolean-options>
          </select>
        </td>
      </tr>
      <tr>
        <td>3.</td>
        <td>Clearing file</td>
        <td>
          <file-upload
            ng-model="\$ctrl.clearingFile"
            ng-required="true"
            validate-uploaded
            max-files="1"
            max-size="'512KB'"
            show-file-name="true"
            show-remarks="false"
            enable-webcam="false">
          </file-upload>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="buttons">
      <button
        class="btn btn-warning"
        ng-click="\$ctrl.redirectBack()">
        Cancel
      </button>
      <button
        class="btn btn-primary"
        ng-click="\$ctrl.postChecks()"
        ng-disabled="\$ctrl.form.\$invalid">
        Post check
      </button>
    </div>
  </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/inventory/check/outgoing/batch-register-inward-check/batch-register-inward-check.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;